import useEventGenericV2 from './use-event-generic'

export default (eventParam = null) =>
  useEventGenericV2({
    eventParam,
    isInitialiser: false
  })
